import Close from '@mui/icons-material/Close';
import { Box, ClickAwayListener, IconButton, Popper, SxProps, Theme } from '@mui/material';
import { RawDraftContentState } from 'draft-js';
import { FC, useState } from 'react';
import { DisplayNote } from '@components/Editor/Viewer';

const closeIconSx: SxProps = {
    '&:hover': {
        color: 'grey.600',
    },

    color: 'grey.400',
    position: 'absolute',
    right: 2,
    top: 2,
};

const popperContentSx: SxProps<Theme> = {
    '& > p': {
        textAlign: 'left',
    },
    '& > p:first-of-type': {
        mt: 5,
    },
    backgroundColor: 'grey.100',
    borderRadius: 1,
    color: 'common.white',
    maxWidth: (t) => t.spacing(80),
    p: 2,
};

interface NoteProps {
    content: RawDraftContentState;
    noteIndex: number;
    sx?: SxProps;
}

const Note: FC<NoteProps> = ({ content, noteIndex, sx }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClickAway = () => {
        if (anchorEl) {
            setAnchorEl(null);
        }
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const open = Boolean(anchorEl);

    return (
        <span>
            <Box
                component="span"
                data-test-id={`note-${noteIndex}`}
                onClick={handleClick}
                sx={{
                    cursor: 'pointer',
                    ml: 0.5,
                    textDecoration: 'underline',
                }}
            >
                ({noteIndex})
            </Box>
            <Popper
                anchorEl={anchorEl}
                open={open}
                placement="bottom-start"
                sx={{ zIndex: (theme) => theme.zIndex.tooltip, ...sx }}
                disablePortal
            >
                <ClickAwayListener onClickAway={handleClickAway}>
                    <Box sx={popperContentSx}>
                        <IconButton
                            aria-label="close"
                            onClick={handleClick}
                            size="small"
                            sx={closeIconSx}
                        >
                            <Close />
                        </IconButton>
                        <DisplayNote value={content} />
                    </Box>
                </ClickAwayListener>
            </Popper>
        </span>
    );
};

export default Note;
